import html2pdf from 'html2pdf.js';

const handleConvertToPDF = async ({
  lang = 'ar',
  elementId = 'printable-content',
  fileName = 'document.pdf'
}) => {
  console.log("elementId" , elementId)
  const originalElement = document.getElementById(elementId);
  console.log("originalElement" , originalElement)
  if (!originalElement) {
    console.error(`Element with ID "${elementId}" not found`);
    return;
  }

  const pdfContainer = document.createElement('div');
  pdfContainer.style.position = 'absolute';
  pdfContainer.style.visibility = 'hidden';
  pdfContainer.style.right = '-9999px';
  pdfContainer.style.width = '794px';

  const contentClone = originalElement.cloneNode(true);

  const styles = {
    width: '100%',
    margin: '0',
    padding: '20px',
    direction: lang === 'ar' ? 'rtl' : 'ltr',
    textAlign: lang === 'ar' ? 'right' : 'left',
    fontSize: '12pt',
    lineHeight: '1.4',
    boxSizing: 'border-box',
    fontFamily: 'Arial, sans-serif'
  };

  Object.assign(contentClone.style, styles);

  const images = contentClone.getElementsByTagName('img');
  for (let img of images) {
    img.style.maxWidth = '100%';
    img.style.height = 'auto';
    img.style.minWidth = '300px';
    img.style.marginLeft = lang === 'ar' ? 'auto' : '0';
    img.style.marginRight = lang === 'ar' ? '0' : 'auto';
    img.style.display = 'block';
  }

  pdfContainer.appendChild(contentClone);
  document.body.appendChild(pdfContainer);

  const options = {
    filename: fileName,
    margin: [10, 10, 10, 10],  
    image: {
      type: 'jpeg',
      quality: 0.98
    },
    html2canvas: {
      scale: 5,  
      useCORS: true,
      letterRendering: true,
      scrollY: -window.scrollY,  
      windowWidth: 794,
      logging: true,
      imageTimeout: 15000, 
      removeContainer: true,
      onclone: (document) => {
        const content = document.querySelector(`#${elementId}`);
        if (content) {
          content.style.direction = lang === 'ar' ? 'rtl' : 'ltr';
          content.style.textAlign = lang === 'ar' ? 'right' : 'left';
        }
      }
    },
    jsPDF: {
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait',
      compress: true,
      precision: 16,
      direction: lang === 'ar' ? 'rtl' : 'ltr',
      putOnlyUsedFonts: true,
      autoPaging: true,  
      enableLinks: true
    },
    pagebreak: {  
      mode: ['avoid-all', 'css', 'legacy'],
      before: '.page-break-before',
      after: '.page-break-after',
      avoid: ['tr', 'td', '.no-break']
    }
  };

  try {
    // انتظار تحميل الصور
    const images = Array.from(contentClone.getElementsByTagName('img'));
    await Promise.all(images.map(img => {
      return new Promise((resolve, reject) => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
        }
      });
    }));

     await html2pdf()
      .from(contentClone)
      .set(options)
      .toPdf()  
      .output('save', fileName);

  } catch (error) {
    console.error('Error converting to PDF:', error);
  } finally {
    document.body.removeChild(pdfContainer);
  }
};

export default handleConvertToPDF;